import React from "react";
import styled from 'styled-components';
import { SECONDARY_COLOR } from "../../color-constants";

const BtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  color: white !important;
  color: var(--se-primary-contrast, white) !important;
  border-radius: 4px;
  ${props => props.height && `height: ${props.height}px;`}
  ${props => props.width && `width: ${props.width}px;`}
  cursor: pointer;

  se-icon {
    transform: scale(1.3);
  }

  :hover {
    color: #FFFFFF;
    color: var(--se-hover-primary-contrast, #FFFFFF);
    background-color: #32AD3C;
    background-color: var(--se-hover-primary, #32AD3C);
  }
`;

class ConfigurationActionButton extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = props.onClick ? props.onClick : (event) => event;
  }

  handleClick(event) {
    this.onClick(event);
  }

  render() {
    return (
      <BtnWrapper title={this.props.title} height={this.props.height} width={this.props.width} onClick={(event) => this.onClick(event)}>
        {this.props.children}
      </BtnWrapper>
    );
  }
}

export default ConfigurationActionButton;
